import { AnimatePresence, motion } from "framer-motion";
import { useLocation, useParams } from "react-router-dom";
import { Step1 } from "./steps/step-1";
import { Step1Upgrade } from "./steps/step-1-upgrade";
import { StepEdit } from "./steps/step-edit";
import { StepReview } from "./steps/step-review";
import { ErrorBoundary } from "@sentry/react";

export const Lora = ({ upgrade }: { upgrade?: boolean }) => {
  const { id, step: _step } = useParams() as {
    id: string;
    step?: "create" | "review" | "upgrade" | "edit";
  };
  let step = _step;

  const location = useLocation();
  const userNameFromState = location.state?.userName;

  let type: "model" | "style" = "model";
  if (id === "model") {
    type = "model";
    step = "create";
  } else if (id === "style") {
    type = "style";
    step = "create";
  } else if (!step || step === "create") {
    // Consulting the lora
    step = "review";
  }

  const renderCurrentStep = () => {
    switch (step) {
      case "create":
        return <Step1 type={type} initialName={userNameFromState} />;
      case "review":
        return <StepReview />;
      case "upgrade":
        return <Step1Upgrade />;
      case "edit":
        return <StepEdit />;
      default:
        return null;
    }
  };

  return (
    <ErrorBoundary>
      <div className="w-full max-w-6xl mx-auto px-4">
        <div className="w-full max-w-3xl mx-auto min-h-available-screen-height flex flex-col justify-center py-8">
          <AnimatePresence mode="wait">
            <motion.div
              key={step}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="w-full"
            >
              {renderCurrentStep()}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </ErrorBoundary>
  );
};
